function readContactCSV(source, separator = 'auto') {
    if (separator === 'auto') {
        const choices = [',', ';', '\t'].map(value => ({ value, width: readContactCSV(source, value)[0]?.length || 0 }));
        separator = choices.sort((a, b) => b.width - a.width)[0].value;
    }
    const rows = []; let row = [], cell = '', quoted = false;
    const text = source.replace(/^\uFEFF/, '');
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (char === '"') { if (quoted && text[i + 1] === '"') { cell += '"'; i++; } else quoted = !quoted; }
        else if (char === separator && !quoted) { row.push(cell); cell = ''; }
        else if (['\r', '\n'].includes(char) && !quoted) { row.push(cell); if (row.some(value => value.trim())) rows.push(row); row = []; cell = ''; if (char === '\r' && text[i + 1] === '\n') i++; }
        else cell += char;
    }
    if (quoted) throw new Error('A quoted CSV value was not closed.');
    row.push(cell); if (row.some(value => value.trim())) rows.push(row);
    return rows;
}
function decodeContactCSV(bytes, encoding = 'auto') {
    let selected = encoding;
    if (selected === 'auto') selected = bytes[0] === 0xff && bytes[1] === 0xfe ? 'utf-16le' : bytes[0] === 0xfe && bytes[1] === 0xff ? 'utf-16be' : 'utf-8';
    try { return new TextDecoder(selected, { fatal: true }).decode(bytes).replace(/^\uFEFF/, ''); }
    catch { throw new Error('This file could not be decoded. Choose its CSV encoding (for example Japanese / Shift JIS) and read it again. UTF-8 works with or without a BOM.'); }
}
const importHeader = heading => {
    const clean = String(heading).toLowerCase().replace(/[^a-z]/g, '');
    const aliases = { fullname: 'name', contactname: 'name', primaryemail: 'email', additionalemails: 'secondaryEmails', jobtitle: 'title', companyname: 'company', recordid: 'recordId', id: 'recordId', lifecyclestage: 'lifecycle', preferredlanguage: 'language', websites: 'website', additionalwebsites: 'additionalWebsites', tag: 'tags', labels: 'tags' };
    return aliases[clean] || clean;
};
module.exports = { readContactCSV, decodeContactCSV, importHeader };
